import React from "react";
import "./crescent.css";

export default function CrescentMoonAnimation({ className = "" }) {
  return (
    <div className={`crescent-wrap ${className}`}>
      <div className="crescent">
        <div className="crescent-shadow" />
      </div>

      <div className="sparkle s1" />
      <div className="sparkle s2" />
      <div className="sparkle s3" />
    </div>
  );
}
